module.exports = __webpack_public_path__ + "static/media/Frame_6.fdb727d6.png";